import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "CoreDialog",
    {
      attrs: {
        "data-qa": "club-info-modal",
        value: _vm.isTopDialog(_vm.componentName),
        size: "fullscreen",
        title: _vm.title,
        "no-click-animation": "",
        persistent: "",
        divider: "",
      },
      scopedSlots: _vm._u([
        {
          key: "prependBtn",
          fn: function ({ btnProps }) {
            return [
              _c(
                VBtn,
                _vm._b(
                  { on: { click: _vm.handleInfoModalClose } },
                  "v-btn",
                  btnProps,
                  false
                ),
                [_c("span", { staticClass: "ui-icon-close-not-a-circle" })]
              ),
            ]
          },
        },
      ]),
    },
    [_vm._v(" "), _vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }